import React from 'react'
import PropTypes from 'prop-types'
import window from 'browser-lib/window'

import ShowAvatar from '@scoir/components-core/dist/components/ShowAvatar'

import filestack from 'common/filestack'

import { imageAsFullImageSrc } from '@scoir/avatar-image-url'

class ShowAvatarAdmissions extends React.Component {
  chooseAvatar() {
    filestack
      .pickAndStore(
        {
          multiple: false,
          mimetypes: ['image/*'],
          cropRatio: 1,
          cropForce: true,
          services: [
            'CONVERT',
            'COMPUTER',
            'FACEBOOK',
            'GOOGLE_DRIVE',
            'DROPBOX',
            'INSTAGRAM',
            'FLICKR',
            'URL',
            'WEBCAM',
          ],
        },
        {
          location: 'S3',
          path: '/profile/',
          access: 'private',
          container: window.FILE_STACK_BUCKET,
        },
      )
      .then((picked) => {
        this.props.onPickAvatar(picked[0])
      })
  }
  render() {
    const { avatarUrl, circle, borderless, onDelete } = this.props
    const avatarSrc = avatarUrl ? imageAsFullImageSrc(avatarUrl) : undefined
    return (
      <ShowAvatar
        src={avatarSrc}
        circle={circle}
        borderless={borderless}
        onDelete={onDelete}
        editable={this.props.editable}
        onEdit={() => this.chooseAvatar()}
      />
    )
  }
}

ShowAvatarAdmissions.propTypes = {
  avatarUrl: PropTypes.string,
  onPickAvatar: PropTypes.func,
  editable: PropTypes.bool,
  circle: PropTypes.bool,
  borderless: PropTypes.bool,
  onDelete: PropTypes.func,
}

export default ShowAvatarAdmissions
